import React from 'react';
import { Link } from 'react-router-dom';
import { BUILD_STAMP } from '../../buildStamp';
import {
    pwaDemoWalkCurrentStep,
    pwaDemoWalkEyebrow,
    pwaDemoWalkKeepNote,
    pwaDemoWalkNote,
    pwaDemoWalkSotLinks,
    pwaDemoWalkStampHint,
    pwaDemoWalkStampLine,
    pwaDemoWalkStepClass,
    pwaDemoWalkSteps,
} from './demoWalk';
import { pwaJobsSotExitHref } from './ordersSurface';

type Props = {
    search?: string;
    openTab?: number;
    jobStatus?: string;
    sot?: string | null;
    preview?: string | null;
    regionLabel?: string;
};

const DemoWalk = ({ search, openTab, jobStatus, sot, preview, regionLabel }: Props) => {
    const current = pwaDemoWalkCurrentStep({ search, openTab, jobStatus, sot, preview });
    return (
        <aside className="pwa-demo-walk" data-testid="pwa-demo-walk" aria-label={pwaDemoWalkNote()}>
            <p className="pwa-demo-walk-eyebrow">{pwaDemoWalkEyebrow(regionLabel || 'glass-pwa')}</p>
            <ol>
                {pwaDemoWalkSteps(search).map((step) => (
                    <li
                        key={step.id}
                        className={pwaDemoWalkStepClass(step.id, current)}
                        aria-current={step.id === current ? 'step' : undefined}
                    >
                        <span className="pwa-demo-walk-n">{step.n}</span>
                        <span>
                            {step.href ? <Link to={step.href}>{step.label}</Link> : step.label}
                            {step.detail ? ` ${step.detail}` : null}
                        </span>
                    </li>
                ))}
            </ol>
            <p className="pwa-demo-walk-keep">{pwaDemoWalkKeepNote()}</p>
            <p className="pwa-demo-walk-sot">
                SoT helpers:{' '}
                {pwaDemoWalkSotLinks(search).map((link, index) => (
                    <React.Fragment key={link.id}>
                        {index > 0 ? ' · ' : null}
                        <Link to={link.href}>{link.label}</Link>
                    </React.Fragment>
                ))}
                {' · '}
                <Link to={pwaJobsSotExitHref(search)}>Exit SoT</Link>
            </p>
            <p className="pwa-demo-walk-stamp">
                <span className="pwa-demo-walk-stamp-id">{pwaDemoWalkStampLine(BUILD_STAMP)}</span>
                <span className="pwa-demo-walk-stamp-hint">{pwaDemoWalkStampHint()}</span>
            </p>
        </aside>
    );
};

export default DemoWalk;
